<template>
    <div :class="['dml-header-nav-item-icon', {'_black': isWhiteTheme }]">
        <a v-if="model.isAuthenticated"
           href="/edytuj-dane"
           data-t="7.1"
           v-on:click="trackEdit"
           class="dml-header-nav-item-icon__wrapper">
            <span class="dml-header-nav-item-icon__avatar-wrapper">
                <img :src="model.avatarUrl" class="dm-avatar dml-header-nav-item-icon__avatar" width="24" height="24" alt="Avatar" />
            </span>
            <span class="dml-header-nav-item-icon__label">Profil</span>
        </a>
        <span v-else data-t="7.1" class="dml-header-nav-item-icon__wrapper">
            <dm-icon name="user" :width="24" :height="24" />
            <span class="dml-header-nav-item-icon__label">Zaloguj</span>
        </span>
        <div v-if="!model.isAuthenticated" class="dml-header-nav-item-icon__content-wrapper">
            <div class="dml-header-nav-item-icon__content">
                <ul class="dml-header-list">
                    <li class="dml-header-list__element">
                        <a href="/zaloguj" data-t="2.5"
                           data-portal="open"
                           data-portal-content="login"
                           v-on:click="trackLogin">
                            <dm-icon name="user" class="dml-header-list__icon" :width="16" :height="16" />
                            <dm-icon name="user-fill" class="dml-header-list__active-icon" :width="16" :height="16" />
                            Zaloguj
                        </a>
                    </li>
                    <li class="dml-header-list__divider"></li>
                    <li class="dml-header-list__element">
                        <a href="/zarejestruj"
                           data-t="2.6"
                           data-portal="open"
                           data-portal-content="register"
                           v-on:click="trackRegister">
                            <dm-icon name="pen" class="dml-header-list__icon" :width="16" :height="16" />
                            <dm-icon name="pen-fill" class="dml-header-list__active-icon" :width="16" :height="16" />
                            Załóż konto
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
    import DM from 'DM';
    import Hub from '../../hub.js';
    import { TrackAction } from '../../utils/track-types-login';
    import IconComponent from '../shared/icon-component.vue';

    export default {
        name: 'dm-wide-header-user',
        components: {
            'dm-icon': IconComponent,
        },
        props: {
            model: {
                type: Object,
                IsAuthenticated: false
            }
        },
        computed: {
            isWhiteTheme() {
                return DM.Config.headerColor === '_white';
            }
        },
        methods: {
            track(trackAction) {
                if (trackAction.Grafana) {
                    Hub.publish(Hub.TRACK_GRAFANA, trackAction.Grafana);
                }
                DM.Utils.trackEvents('mega_menu', 'click_menu', trackAction.GA_Value);
            },
            trackLogin: function () {
                this.track(TrackAction.LOGIN_CLICK);
            },
            trackRegister: function () {
                this.track(TrackAction.REGISTER_CLICK);
            },
            trackEdit: function () {
                this.track(TrackAction.REGISTER_CLICK);
            },
        }
    };
</script>
